import { upperFirst } from 'lodash'

import { proxy } from '@/utils'

import render from './render'

export default function(options) {
  return {
    name: options.path.split('.').map(upperFirst).join(''),

    mixins: [ proxy({ type: 'array' }) ],

    render(h) {
      return render.call(this, h, options)
    }
  }
}
